import React from 'react'
import styles from './styles.module.css'
import caretDown from '../../../../../../img/caretDownGeneric.svg'
import { taxonomyLevel2Values } from './TaxonomyLevel2Values'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from '../../../../../images/circle-info-regular-full.svg'

function Taxonomy2 ({ localTaxonomyLevel2, setLocalTaxonomyLevel2 }) {
  const handleTaxonomyChange = event => {
    setLocalTaxonomyLevel2(event.target.value.toLowerCase())
  }

  return (
    <div className={styles.taxonomyLevel2InputWrapper}>
      <div className={styles.inlineLabel}>
        <label className={styles.taxonomyLevel2Label}>Taxonomy (level 2)</label>
        <Tooltip
          title='Filter by second-level product taxonomy. Options depend on the selected level 1 category.'
          arrow
          placement='top'
          slotProps={{
            popper: {
              sx: {
                '& .MuiTooltip-tooltip': {
                  maxWidth: 500,
                  fontSize: '13px',
                  padding: '8px'
                }
              }
            }
          }}
        >
          <img
            src={infoIcon}
            alt='Taxonomy (level 2) help'
            width={14}
            height={14}
            className={styles.infoIcon}
            tabIndex={0}
          />
        </Tooltip>
      </div>

      <div>
        <select
          className={styles.taxonomyLevel2DropBox}
          name='taxonomyLevel2'
          id='taxonomyLevel2'
          value={localTaxonomyLevel2}
          onChange={handleTaxonomyChange}
        >
          <option value=''>Select level 1</option>
          {taxonomyLevel2Values.map((value, index) => (
            <option key={index} value={value.toLowerCase()}>
              {value}
            </option>
          ))}
        </select>
        <img
          src={caretDown}
          alt='arrow'
          className={styles.taxonomyLevel2CustomArrow}
        />
      </div>
    </div>
  )
}

export default Taxonomy2
